import React, { ReactNode, createContext } from 'react';

interface ContextInterface {
  featureFlags: Array<string>;
}

export const FeatureFlagContext = createContext<ContextInterface>({
  featureFlags: [],
});

interface FeatureFlagProviderProps {
  children: ReactNode;
  featureFlags: Array<string>;
}

const FeatureFlagProvider = ({ children, featureFlags }: FeatureFlagProviderProps) => {
  return (
    <FeatureFlagContext.Provider value={{ featureFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlagProvider;
